export const LOADING = 'LOADING';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';
export const CREATE_BOOKING = 'CREATE_BOOKING';
export const BOOKING_TYPE = 'BOOKING_TYPE';
export const BASIC_INFO = 'BASIC_INFO';
export const APPOINTMENT_DETAIL = 'APPOINTMENT_DETAIL';
export const SCREENING = 'SCREENING';
export const GET_BOOKING_DATA = 'GET_BOOKING_DATA';
export const GET_BOOKING_DETAIL_DATA = 'GET_BOOKING_DETAIL_DATA';
export const DELETE_BOOKING_DATA = 'DELETE_BOOKING_DATA';
export const APPROVED_BOOKING = 'APPROVED_BOOKING';
export const DECLINED_BOOKING = 'DECLINED_BOOKING';
export const GET_EMAIL_NOTIFICATION = 'GET_EMAIL_NOTIFICATION';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const SUPER_UPDATE_USER_DETAILS = 'SUPER_UPDATE_USER_DETAILS';
export const GET_ALL_USERS_DATA = 'GET_ALL_USERS_DATA';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const DELETE_USERS = 'DELETE_USERS';
export const SEARCH_USERS = 'SEARCH_USERS';
export const CREATE_NEW_PERK = 'CREATE_NEW_PERK';
export const UPDATE_NEW_PERK = 'UPDATE_NEW_PERK';
export const GET_PERK_DATA = 'GET_PERK_DATA';
export const DELETE_PERK_DATA = 'DELETE_PERK_DATA';
export const UPDATE_CUSTOM_LINKS = 'UPDATE_CUSTOM_LINKS';
export const ADD_NEW_USER = 'ADD_NEW_USER';
